import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const trackIntercomFinAppEvent = createTrackerForCategory('Intercom Fin App');
export const trackShowMessenger = () => trackIntercomFinAppEvent('Show Intercom Chatbot');
export const trackHideMessenger = () => trackIntercomFinAppEvent('Hide Intercom Chatbot');

export const trackGetHelpButtonClicked = () => trackIntercomFinAppEvent('Get Help Button Clicked');
export const trackGetHelpButtonDismissed = () => trackIntercomFinAppEvent('Get Help Button Dismissed');
